module.exports = __webpack_public_path__ + "static/media/australia.2fa13c5d.jpg";